import React from "react";
import Layout from 'layout/index.js'

import { Link } from 'react-router-dom';

import SearchIcon from '@mui/icons-material/Search';


import { authenticationService } from 'auth/authenticationService'
import {
          Paper,
          Box,
          Button,
          // Typography,
          Alert,
          TextField,
          TableSortLabel,TablePagination,TableContainer,Table,TableRow,TableHead,TableBody,TableCell

        } from '@mui/material';
  
const headCells = [
  { id: "created_at", numeric: false, disablePadding: false, label: "Fecha creación", sorting: true},
  { id: "name", numeric: false,disablePadding: false,label: "Nombre lista", sorting: true},
  { id: "ver_lista", numeric: false,disablePadding: false,label: "Ver Lista", sorting: false},
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          !headCell.sorting ? <TableCell key={headCell.id}>{headCell.label}</TableCell> : (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className='hideSort'>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
          )
        ))}
      </TableRow>
    </TableHead>
  );
}

function encodeQueryData(data) {
   const ret = [];
   for (let d in data)
     ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
   return ret.join('&');
}

class Listas extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

      objects: [],

      html: {
        list: true,
      },
      filters: {
      },
      pagination:{
        page: 0,
        pages_num: 1,
        rows_num: -1,
        rows_per_page: 10,
      },
      sorting: {
        order_by:'created_at',
        order:'desc',
      },
    };

    this.handleLoad = this.handleLoad.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.createNew = this.createNew.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }



  handleChangePage(event, page){
    this.setState(prevState => ({
      pagination: {
        ...prevState.pagination,
          page: page,
      }}), ()=> this.handleLoad());

  }
  handleChangeRowsPerPage(event){
    this.setState(prevState => ({
      pagination: {
        ...prevState.pagination,
          rows_per_page: event.target.value,
      }}), ()=> this.handleLoad());
  }

  handleSort(event, property){
    const isAsc = this.state.sorting.order_by === property && this.state.sorting.order === "asc";
    this.setState(prevState => ({
      sorting: {
          ...prevState.sorting,
          order: isAsc ? "desc" : "asc",
          order_by: property,
    }}),()=>this.handleLoad()
    );

  }


  handleLoad(){
    var params = {
        page: this.state.pagination.page+1,
        order_by: this.state.sorting.order_by,
        order: this.state.sorting.order,
        rows_per_page: this.state.pagination.rows_per_page,
    };

    if(this.state.filters.nombre && this.state.filters.nombre!==''){
      params['nombre'] = this.state.filters.nombre;
    }
    var query = encodeQueryData(params)

    authenticationService.fetchApi({
      url:'/permisos/lista/?'+query,
      method: 'GET',
    })
    .then(result=>{
      let list = false;
      if(result.data.length > 0){
        list=true;
      }
      this.setState(prevState => ({
        pagination: {
            ...prevState.pagination,
            rows_num: result.rows_num
        },
        html: {
          ...prevState.html,
          list: list,
        },
        objects: result.data
      }));
    })
    .catch(err=>{
      
    });

  }

  componentDidMount(){
    this.handleLoad();
  }

  createNew(){
    this.setState(prevState => ({
      html: {
        ...prevState.html,
        list: false,
      },
    }));
  }

  handleFilterChange(event) {
    const { filters } = { ...this.state };
    const currentState = filters;
    const { name, value } = event.target;
    currentState[name] = value;
    this.setState({ filters: currentState },()=>{
      this.handleLoad();
    });

  }

  render() {
    return (
    <Layout title='Vehículos'>
      
      <Paper>
        <Box p={1} m={1}>

          <Box p={1} m={1} align='right'>
            <Button component={Link} to={'/permisos/lista/new'} color='primary' variant='contained'>Agregar una nueva lista</Button>
          </Box>
          
          <Box>
            <TextField  name='nombre'
                        id='nombre'
                        label='Buscar por nombre de lista'
                        placeholder='Buscar por nombre de lista'
                        fullWidth
                        maxLength='100'
                        value={this.state.filters.patente}
                        onChange={this.handleFilterChange}
                        variant="standard"
                        />
          </Box>

          <Box>


            {this.state.objects.length>0 && this.state.html.list &&
            <Box p={1}>
              <TablePagination
                labelRowsPerPage='Resultados por página'
                component="div"
                count={this.state.pagination.rows_num}
                page={this.state.pagination.page}
                onPageChange={this.handleChangePage}
                rowsPerPage={this.state.pagination.rows_per_page}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
              />
              <TableContainer>
                <Table size="small" >
                  <EnhancedTableHead
                    order={this.state.sorting.order}
                    orderBy={this.state.sorting.order_by}
                    onRequestSort={this.handleSort}
                  />
                  <TableBody>
                  {this.state.objects.map((object) => {
                    return(
                      <TableRow key={object.lista_uuid}>
                        <TableCell>
                          {(new Date(object.created_at)).toLocaleDateString('es-CL')}
                        </TableCell>
                        <TableCell>
                          {object.nombre}
                        </TableCell>
                        <TableCell>
                          <Button component={Link} to={'/permisos/lista/'+object.lista_uuid} color='primary' startIcon={<SearchIcon />}>Ver lista</Button>
                        </TableCell>
                      </TableRow>
                    )
                  })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            }
            {this.state.objects.length===0 &&
            <Box>
              <Box p={1}>
                <Alert severity='warning'>
                  No se encontraron listas
                </Alert>
              </Box>
            </Box>
            }
          </Box>
        </Box>
      </Paper>

    </Layout>
    );
  }
}

export default Listas;
